export const BUILTIN_THEATRE_ASSETS = {
  DICE_SET: 'DICE_SET',

  DOIS_TERRAIN: "DOIS_TERRAIN",
  DOIS_TERRAIN_ICON: "DOIS_TERRAIN_ICON",

  PALADIN: "PALADIN"
}